import { useMemo } from 'react';

import { usePlanFeature } from '~/hooks/usePlanFeature';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

type ShareFeatureFlags = {
  commentsEnabled: boolean;
  canManageCommentsEnabled: boolean;
  customFieldsEnabled: boolean;
  requireAccountEnabled: boolean;
  passcodeEnabled: boolean;
  expirationDateEnabled: boolean;
};

export const useShareSettings = (): ShareFeatureFlags => {
  const { data: subscription } = useSubscriptionContext();
  const canUsePasscodeProtectedLinks = usePlanFeature('passcodeProtectedLinks');

  return useMemo<ShareFeatureFlags>(() => {
    const hasCreator = subscription?.isOnCreatorPlan;
    const hasPlus = subscription?.isOnPlusPlan;
    const hasPro = subscription?.isOnProPlan; // includes business & enterprise

    return {
      commentsEnabled: !!(hasCreator || hasPlus || hasPro), // Creator+ can view comments
      canManageCommentsEnabled: !!(hasPlus || hasPro), // Plus+ can allow commenting
      customFieldsEnabled: !!(hasPlus || hasPro),
      requireAccountEnabled: !!(hasPlus || hasPro),
      passcodeEnabled: canUsePasscodeProtectedLinks,
      expirationDateEnabled: !!hasPro,
    };
  }, [subscription, canUsePasscodeProtectedLinks]);
};
